import { createColumnHelper } from "@tanstack/react-table";
import { useState, useEffect } from "react";
import DataService from "../../../../../../Service";
import { orgGroupedColumns } from "../OrganisationColumns";
import { partnerGroupedColumns } from "../PartnerColumns";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";

const useColumnsDataDefiner = (fetchApi, liveViewType) => {
  const groupedColumns = {
    organisation: orgGroupedColumns,
    partner: partnerGroupedColumns,
    employee: [],
  };

  const [columns, setColumns] = useState([]);
  const [activeData, setActiveData] = useState([]);
  const columnHelper = createColumnHelper();

  const getDataFunc = () => {
    return DataService.getDirectData(fetchApi);
  };

  const selectFunc = (response) => {
    const mappingObj = {};
    const columns = groupedColumns[liveViewType].map((group) => {
      return columnHelper.group({
        id: group.id,
        header: group.groupName,
        columns: group.columns.map((individual, ind) => {
          mappingObj[individual.id] = individual.label;
          return columnHelper.accessor(individual.id, {
            header: individual.label,
            enablePinning: true,
            enableColumnFilter: true,
            filterFn: "filterOut",
            enableGlobalFilter: true,
            isEditable: true,
            ...individual,
          });
        }),
      });
    });
    const actionButton = columnHelper.accessor("edit", {
      header: "Actions",
      id: "edit",
      enablePinning: true,
      enableColumnFilter: false,
      enableSorting: false,
      isEditable: false,
      enableGlobalFilter: false,
      componentType: "action",
      pinCondition: "right",
      // size: 80,
    });
    let data = [];
    columns.push(actionButton);
    const dataKeys = {
      organisation: "data",
      partner: "partner_profiles",
    };
    if (columns.length) {
      data = response[dataKeys[liveViewType]]?.map((el, ind) => {
        const elem = {};
        let dataObj = {};
        if (liveViewType === "organisation") {
          dataObj = el["datum"];
        }
        if (liveViewType === "partner") {
          // dataObj = el
          dataObj = {
            ...el,
            PartnerGdpr_consent_status: el.PartnerGdpr_consent_status
              ? "Yes"
              : "No",
            PartnerCommissionInformation_commission:
              el.PartnerCommissionInformation_commission ? "Yes" : "No",
            PartnerProfile_currently_available_for_assignment:
              el.PartnerProfile_currently_available_for_assignment === "true"
                ? "Yes"
                : "No",
            PartnerQuestionnaire_worked_in_public_sector:
              el.PartnerQuestionnaire_worked_in_public_sector ? "Yes" : "No",
            PartnerQuestionnaire_worked_in_private_sector:
              el.PartnerQuestionnaire_worked_in_private_sector ? "Yes" : "No",
            PartnerProfile_cv_resume: el.PartnerProfile_cv_resume
              ? "Yes"
              : "No",
            PartnerProfile_send_open_questionnaire_section:
              el.PartnerProfile_send_open_questionnaire_section ? "Yes" : "No",
            PartnerProfile_acuity_profile_created:
              el.PartnerProfile_acuity_profile_created ? "Yes" : "No",
            PartnerProfile_Bame: el.PartnerProfile_Bame ? "Yes" : "No",
            PartnerProfile_onboarded: el.PartnerProfile_onboarded
              ? "Yes"
              : "No",
            PartnerProfile_assignment_sourced_for:
              el.PartnerProfile_assignment_sourced_for === "true"
                ? "Yes"
                : "No",
          };
        }

        for (let i in mappingObj) {
          elem[i] = dataObj[i];
        }
        return { ...elem, id: dataObj?.id };
      });
    }

    return { data, columns };
  };
  const dispatch = useDispatch();

  const {
    data,
    isLoading: isDataLoading,
    refetch: refetchData,
    isRefetching,
  } = useQuery(`${liveViewType}_live_view`, getDataFunc, {
    select: selectFunc,
    staleTime: 1800000,
    refetchOnWindowFocus: false,
    cacheTime: 1800000,
    onSuccess: (data) => {
      setActiveData(data?.data);
      setColumns(data?.columns);
      dispatch(showSnackbar("success", ["Data updated successfully"], 1000));
    },
    onError: () => {
      dispatch(showSnackbar("error", ["Something went wrong"], 1000));
    },
  });

  useEffect(() => {
    console.log("visiting", data, activeData);
    if (data && activeData.length === 0) {
      setActiveData(data.data);
      setColumns(data.columns);
      refetchData();
      dispatch(
        showSnackbar(
          "error",
          [
            "Loading updated data",
            "Please wait until the loading is completed",
          ],
          6000
        )
      );
    }
  }, [data]);
  return {
    activeData,
    setActiveData,
    columns,
    setColumns,
    isDataLoading,
    refetchData,
    isRefetching,
  };
};
export default useColumnsDataDefiner;
